
export default class PageInfoElement extends HTMLElement {
    constructor(){
        super();
    }
}

customElements.define('page-info', PageInfoElement);